import {
  Component, ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild, ViewChildren,
} from '@angular/core';
import { OrganisationService } from '../../../../services/organisation/organisation.service';
import { AlertBannerService, AlertType } from '../../../../lib/alert-banner';
import moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';
import * as _ from 'lodash';
import { OrgEditRoleModalComponent } from '../org-edit-role-modal/org-edit-role-modal.component';
import * as Cookies from 'js-cookie';
import { PermissionsService } from '../../../../services/permissions/permissions.service';
import { ConstantsService } from '../../../../services/constants/constants.service';
import { OrgUsersService } from '../../services/org-users.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { OrgUserProfileModalComponent } from '../org-user-profile-modal/org-user-profile-modal.component';
import { OrgRemoveUserModalComponent } from '../org-remove-user-modal/org-remove-user-modal.component';
import cloneDeep from 'lodash/cloneDeep';
import { ManageSurveyPermissionsModalComponent } from '../manage-survey-permissions-modal/manage-survey-permissions-modal.component';
import { ManageTeamsComponent } from '../manage-teams/manage-teams.component';
import { NewInviteUserComponent } from '../new-invite-user/new-invite-user.component';
import { UnsavedChangesComponent } from '../unsaved-changes/unsaved-changes.component';
import { NewManageUserComponent } from '../new-manage-user/new-manage-user.component';
import {
  TrustMarketplaceStatusService
} from "../../../../services/trust-marketplace-status/trust-marketplace-status.service";

@Component({
  selector: 'app-org-user',
  templateUrl: './org-user.component.pug',
  styleUrls: ['./org-user.component.scss'],
  standalone: false
})
export class OrgUserComponent implements OnInit, OnChanges {
  @Input() org: any;
  @Input() searchedData = '';
  @Output() showInvitedUsers = new EventEmitter();
  @Output() loader = new EventEmitter();
  orgUsers: any;
  @Input() searchQuery = { type: '', search: '' };
  invitedUserCount!: number;
  rolesToolTipData = '';
  total = 5;
  rowsPerView = 20;
  currentPage = 1;
  displayAlert = false;
  kebabMenuOpen = false;
  @ViewChildren('userCardMenu') kebabMenus:any;
  @ViewChild('userInviteeContainer') userContainer:any;

  filterOptions = [
    { label: $localize`Owner`, value: 'owner' },
    {
      label: $localize`Admin`,
      value: 'admin',
    },
    { label: $localize`Member`, value: 'member' },
    {
      label: $localize`Member (restricted)`,
      value: 'member (restricted)',
    },
    { label: $localize`Xref Support`, value: 'support' },
  ];
  @Input() filters: any;
  groupDropDownOptions = [
    {
      key: 'Last access',
      value: [
        { label: 'A-Z', sortString: 'last_access' },
        { label: 'Z-A', sortString: '-last_access' },
      ],
    },

    {
      key: 'group-end',
      value: [],
    },
    {
      key: 'Invited',
      value: [
        { label: 'A-Z', sortString: 'invited' },
        { label: 'Z-A', sortString: '-invited' },
      ],
    },
    {
      key: 'group-end',
      value: [],
    },
    {
      key: 'Name',
      value: [
        { label: 'Ascending', sortString: 'name' },
        { label: 'Descending', sortString: '-name' },
      ],
    },
  ];
  get newSortOptions() {
    return [
      {
        key: $localize`Name`,
        value: [
          { label: $localize`A-Z`, sortString: 'name' },
          { label: $localize`Z-A`, sortString: '-name' },
        ],
      },
      {
        key: 'group-end',
        value: [],
      },
      {
        key: $localize`Invited`,
        value: [
          { label: $localize`Oldest`, sortString: 'invited' },
          { label: $localize`Newest`, sortString: '-invited' },
        ],
      },
      {
        key: 'group-end',
        value: [],
      },
      {
        key: $localize`Last access`,
        value: [
          { label: $localize`Oldest`, sortString: 'last_access' },
          { label: $localize`Newest`, sortString: '-last_access' },
        ],
      },
    ];
  }
  sortOptions = [
    {
      label: $localize`Last access`,
      type: 'number',
      value: 'last_access',
    },
    {
      label: $localize`Invited`,
      type: 'number',
      value: 'invited',
    },
    {
      label: $localize`Name`,
      type: 'word',
      value: 'name',
    },
  ];
  sortString = 'last_access';
  sortOrder = 'desc';
  username = '';
  userRole: any = '';
  allowRemoveOwner = false;
  allowRemove = false;
  allowEditRole = false;
  onfocus = false;
  private bsModalRef: any;
  private model: any;
  manageUserDropDownOptions = [
    { key: '1', value: 'View user', divider: false, disabled: true },
    { key: '2', value: 'Manage user role', divider: false, disabled: true },
    { key: '3', value: 'Manage teams', divider: false, disabled: true },
    {
      key: '4',
      value: 'Manage survey permissions',
      divider: false,
      disabled: true,
    },
    {
      key: '5',
      value: 'Clone settings to new user',
      divider: false,
      disabled: true,
    },
    { key: '6', value: 'Remove user', divider: true, disabled: true },
  ];

  selectedTab = 'Users';
  sharedData: any;
  label = '';
  toolTipHeading = $localize`Product permissions`

  constructor(
    private organisationService: OrganisationService,
    private alertList: AlertBannerService,
    private modalService: BsModalService,
    private orgUserService: OrgUsersService,
    private permissions: PermissionsService,
    private sanitizer: DomSanitizer,
    public trustMarketplaceStatusService: TrustMarketplaceStatusService,
  ) {
    this.onSearch = _.debounce(this.onSearch, ConstantsService.DEBOUNCE_RATE);
  }

  ngOnInit(): void {
    this.username = this.permissions.username;
    this.userRole = this.permissions.userRole;
    this.label = `${this.newSortOptions[4].key} (${this.newSortOptions[4].value[0].label})`;
    if (this.searchQuery.type !== "name" && this.searchQuery.search){
      this.displayAlert = true;
    }
    this.numberOfInvitedUsers()
    this.setManageUserOptions()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.permissions.hasUserOrgPermission('remove_an_owner')) {
      this.allowRemoveOwner = true;
    }
    if (this.permissions.hasUserOrgPermission('remove_invitation')) {
      this.allowRemove = true;
    }
    if (this.permissions.hasUserOrgPermission('set_others_user_role')) {
      this.allowEditRole = true;
    }
    this.username = this.permissions.username;
    this.userRole = this.permissions.userRole;

    if (this.searchQuery.type !== 'name' && this.searchQuery.search) {
      this.displayAlert = true;
    }
    else if(this.searchQuery.type !== "name"){
      this.displayAlert = this.searchQuery.search !== '';
    }
    this.loadOrgUsers()
    if(this.displayAlert){
      this.numberOfInvitedUsers()
    }

  }

  onPageChange(pageNumber) {
    this.currentPage = pageNumber;
    this.updateSharedData();
    this.loadOrgUsers();

  }
  setManageUserOptions(){
    this.manageUserDropDownOptions = [
      { key: '1', value: $localize`View user`, divider: false, disabled: true },
      { key: '2', value: $localize`Manage user role`, divider: false, disabled: true },
      { key: '3', value: $localize`Manage teams`, divider: false, disabled: true },
      {
        key: '4',
        value: $localize`Manage survey permissions`,
        divider: false,
        disabled: true,
      },
      {
        key: '5',
        value: $localize`Clone settings to new user`,
        divider: false,
        disabled: true,
      },
      { key: '6', value: $localize`Remove user`, divider: true, disabled: true },
    ]
  }

  numberOfInvitedUsers() {
    if (this.org === undefined) return;
    this.organisationService.retrieveInvitedUserCount(this.searchQuery.type, this.searchQuery.search, this.filters).subscribe(data => {
      this.invitedUserCount = data['total_invitees'];
      if(this.invitedUserCount==0){
        this.displayAlert = false;
      }
    }, error => {
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    })

  }

  onPageSizeChange(rowsPerView) {
    this.rowsPerView = rowsPerView;
    this.currentPage = 1;

    this.loadOrgUsers();
    this.updateSharedData();

  }

  onNewSortChange(event: {
    sortString: string;
    key: string;
    label: string;
  }): void {
    let sortString = event.sortString;
    this.label = `${event.key} (${event.label})`;
    if (sortString.includes('-')) {
      this.sortOrder = 'desc';
      this.sortString = sortString.substring(1);
    } else {
      this.sortOrder = 'asc';
      this.sortString = sortString;
    }
    this.loadOrgUsers();
    this.updateSharedData();
  }

  onSortChange(sortString: any): void {
    if (sortString.includes('-')) {
      this.sortOrder = 'desc';
      this.sortString = sortString.substring(1);
    } else {
      this.sortOrder = 'asc';
      this.sortString = sortString;
    }
    this.loadOrgUsers();
    this.updateSharedData();
  }

  onFilterChange(filters) {
    this.filters = filters;
  }

  onSearch(event) {
  }

  hasAdminRoleForMember(permissions, userRoles) {
    let hasAdminRole = false;
    for (const key in userRoles) {
      if (userRoles[key] !== "None" && permissions[key] === 2) {
        hasAdminRole =  true;
      } else if (userRoles[key] !== "None" && permissions[key] != 2) {
        return false;
      }
    }
    return hasAdminRole;
  }

  hasAdminRoleForSupport(permissions) {
    for (const key in permissions) {
      if (permissions[key] === 2) {
        return true;
      }
    }
    return false;
  }

  hasDeletePermission(user){
    if (this.permissions?.role?.['role'] === 'member' && user.roles?.['role'] === 'member') {
      return this.hasAdminRoleForMember(this.permissions.role['products'], user.roles['products'])
    }
    if (this.permissions?.role?.['role'] === 'member' && user.roles?.['role'] === 'support') {
      return this.hasAdminRoleForSupport(this.permissions.role['products'])
    }
    const ownerViewUser =
      this.permissions.hasPermission(
        'can_manage_reference_invitees_and_users'
      ) &&
      this.permissions.hasPermission(
        'can_manage_exit_invitees_and_users'
      ) &&
      this.permissions.hasPermission(
        'can_manage_pulse_invitees_and_users'
      ) &&
      this.permissions.hasPermission(
        'can_manage_backgroundcheck_invitees_and_users'
      );

    if (
      user.roles?.role.toLowerCase() &&
      'support' == user.roles?.role.toLowerCase() &&
      this.permissions.hasPermission('can_remove_support_user')
    ) {
      return true
    }
    else if (
      user.roles?.role.toLowerCase() &&
      'owner' == user.roles?.role.toLowerCase() &&
      this.permissions.hasPermission('can_remove_owner_user')
    ) {
      return true
    }
    else if (
      user.roles?.role.toLowerCase() &&
      !['support', 'owner'].includes(user.roles?.role.toLowerCase())
    ) {
      return true
    }
    return false
  }

  deleteUser(user) {

      let initialState = {
      headerText: $localize`Remove user`,
      reinstatementText: $localize`To reinstate a user who has been removed, you will need to send them a new invitation.`,
      confirmationText: $localize`\nAre you sure you want to remove this user?`,
      noPermissionText: $localize`This user has product access you do not have permission to remove. Please contact your account owner to remove the invitation.`,
      cancelButtonLabel: $localize`Cancel`,
      removeButtonLabel: $localize`Remove`,
      hasPermission: this.hasDeletePermission(user),
      };

      this.bsModalRef = this.modalService.show(OrgRemoveUserModalComponent, {
        class: 'modal-dialog-centered max-width-552',
        initialState,
      });


    this.bsModalRef.content?.selection.subscribe((res) => {
      if (res === true) {
        this.loader.emit(false);
          this.organisationService.deleteOrganisationUser(user).subscribe(
            (data) => {
              this.alertList.append([
                {
                  type: AlertType.SUCCESS,
                  message: $localize`${
                        user.first_name + ' ' + user.last_name
                      } has been removed. If this was done in error, you can invite ${
                        user['first_name']
                      } to rejoin.`,
                  keepOnRouteChange: true,
                },
              ]);
              _.remove(this.orgUsers, user);
              this.loader.emit(true);
            },
            (error) => {
              this.alertList.append([
                {
                  type: AlertType.DANGER,
                  message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
                  keepOnRouteChange: true,
                },
              ]);
              this.loader.emit(true);
            }
          );
      }
    });
  }

  showEditUserModal(user) {
    let data = user;
    data['isUserEdit'] = true;
    let initialState = { data: data };
    this.bsModalRef = this.modalService.show(OrgEditRoleModalComponent, {
      class: 'modal-dialog-centered modal-lg',
      initialState,
    });
    this.bsModalRef.content.nextClick.subscribe((res) => {
      let editDetails = res['data'];
      editDetails['payload']['user_uid'] = user['user_uid'];
      this.saveUser(editDetails);
    });
  }

  loadOrgUsers() {
    if (this.org === undefined) return;
    this.loader.emit(false);
    this.organisationService
      .retrieveOrganisationUsers(
        this.searchQuery.type,
        this.searchQuery.search,
        this.rowsPerView,
        this.currentPage,
        this.sortString,
        this.sortOrder,
        this.filters
      )
      .subscribe(
        (data) => {
          this.orgUsers = data['users'];
          this.translateForDisplay();
          this.total = data['total_users'];
          this.loader.emit(true);
        },
        (error) => {
          console.log(error);
          this.loader.emit(true);
          this.alertList.append([
            {
              type: AlertType.DANGER,
              message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
              keepOnRouteChange: true,
            },
          ]);
        }
      );
  }

  saveUser(data) {
      this.organisationService
        .updateOrganisationUserAndInvitedUser(data.payload, data.isUserEdit)
        .subscribe(
          (data) => {
            this.alertList.append([
              {
                type: AlertType.SUCCESS,
                message: $localize`Success! Changes have been saved.`,
                keepOnRouteChange: true,
              },
            ]);
            this.loadOrgUsers();
          },
          (error) => {
            console.log(error);
            this.alertList.append([
              {
                type: AlertType.DANGER,
                message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
                keepOnRouteChange: true,
              },
            ]);
          }
        );
  }

  updateRole(rolesObject) {
    if (rolesObject && rolesObject.products) {
      const products = rolesObject.products;
      for (let product in products) {
        if (products.hasOwnProperty(product)) {
          const roleNumber = products[product];

          if (
            ConstantsService.PRODUCT_NUMBER_TO_ROLE_MAP.hasOwnProperty(
              roleNumber
            )
          ) {
            products[product] =
              ConstantsService.PRODUCT_NUMBER_TO_ROLE_MAP[roleNumber];
          }
        }
      }
      for (let product in ConstantsService.DEFAULT_ROLES) {
        if (!products.hasOwnProperty(product)) {
          rolesObject.products[product] = ConstantsService.DEFAULT_ROLES[product]
        }
      }
    }
    return rolesObject;
  }

  mapToolTip(UserRoles){
    let toolTipRoles = {'role':'member', products:{}}
    for(let product in ConstantsService.DEFAULT_ROLES_LOCALISED){
      if(UserRoles.products?.hasOwnProperty(product)){
            if(product === "Background Checks"){
              this.trustMarketplaceStatusService.trustAdminStatus.subscribe(
                  res => {
                    if(res == undefined && res != false){
                      toolTipRoles.products[ConstantsService.DEFAULT_ROLES_LOCALISED[product]] = UserRoles.products[product]
                    }
                  }
                );
            }
            else{
              toolTipRoles.products[ConstantsService.DEFAULT_ROLES_LOCALISED[product]] = UserRoles.products[product]
            }
          }
    }
    return JSON.stringify(toolTipRoles)
  }

  translateForDisplay() {
    for (let orgUser of this.orgUsers) {
      if (orgUser?.roles?.role === 'member') {
        orgUser.roles = this.updateRole(orgUser.roles);
        orgUser['rolesToolTipData'] = this.mapToolTip(orgUser.roles)
      }
      const userId = Cookies.get('user_uid');
      orgUser.dropDown = cloneDeep(this.manageUserDropDownOptions);
      // view user permission
      // manage teams can_manage_reference_invitees_and_users
      const viewUser =
        this.permissions.hasPermission(
          'can_manage_reference_invitees_and_users'
        ) ||
        this.permissions.hasPermission(
          'can_manage_exit_invitees_and_users'
        ) ||
        this.permissions.hasPermission(
          'can_manage_pulse_invitees_and_users'
        ) ||
        this.permissions.hasPermission(
          'can_manage_backgroundcheck_invitees_and_users'
        );
      const ownerViewUser =
        this.permissions.hasPermission(
          'can_manage_reference_invitees_and_users'
        ) &&
        this.permissions.hasPermission(
          'can_manage_exit_invitees_and_users'
        ) &&
        this.permissions.hasPermission(
          'can_manage_pulse_invitees_and_users'
        ) &&
        this.permissions.hasPermission(
          'can_manage_backgroundcheck_invitees_and_users'
        );
      if (orgUser.roles?.role && orgUser.roles?.role?.toLowerCase() && viewUser) {
        orgUser.dropDown[2]['disabled'] = false;
        orgUser.dropDown[0]['disabled'] = false;
      }

      // if current user and orgUser is same then manage user role is disable
      const manageRole =
        this.permissions.hasPermission('can_set_reference_role') ||
        this.permissions.hasPermission('can_set_pulse_role') ||
        this.permissions.hasPermission('can_set_exit_role') ||
        this.permissions.hasPermission('can_set_backgroundcheck_role');
      if (orgUser.roles?.role &&
        orgUser.roles?.role?.toLowerCase() &&
        userId != orgUser.user_uid &&
        manageRole
      ) {
        if (orgUser.roles?.role && ('owner' != orgUser.roles?.role?.toLowerCase() || ('owner' == orgUser.roles?.role?.toLowerCase() && this.userRole?.role?.toLowerCase() == 'support'))) {
          orgUser.dropDown[1]['disabled'] = false;
        }
      }

      // manage survey permission
      const manageSurvey =
        this.permissions.hasPermission(
          'can_manage_reference_user_survey_permissions'
        ) ||
        this.permissions.hasPermission(
          'can_manage_pulse_user_survey_permissions'
        ) ||
        this.permissions.hasPermission(
          'can_manage_exit_user_survey_permissions'
        ) ||
        this.permissions.hasPermission(
          'can_manage_backgroundcheck_user_survey_permissions'
        ) ||
        this.permissions.hasPermission(
          'can_manage_reference_user_survey_permissions_with_survey_perms'
        ) ||
        this.permissions.hasPermission(
          'can_manage_pulse_user_survey_permissions_with_survey_perms'
        ) ||
        this.permissions.hasPermission(
          'can_manage_exit_user_survey_permissions_with_survey_perms'
        ) ||
        this.permissions.hasPermission(
          'can_manage_backgroundcheck_user_survey_permissions_with_survey_perms'
        );
      if (orgUser.roles?.role && orgUser.roles?.role?.toLowerCase() && manageSurvey) {
        orgUser.dropDown[3]['disabled'] = false;
      }
      // if orguser is owner/support then cloned setting is disable
      if (orgUser.roles?.role &&
        orgUser.roles?.role?.toLowerCase() &&
        !['support', 'owner'].includes(orgUser.roles?.role?.toLowerCase()) &&
        viewUser
      ) {
        if (ownerViewUser) {
          orgUser.dropDown[4]['disabled'] = false;
        } else {
          if (this.hasProductPermission(this.userRole, orgUser.roles)) {
            orgUser.dropDown[4]['disabled'] = false;
          }
        }
      }

      // remove user/inviteee can_manage_reference_invitees_and_users + owner check + support check
      if (orgUser.roles?.role &&
        orgUser.roles?.role?.toLowerCase() &&
        'support' == orgUser.roles?.role?.toLowerCase() &&
        this.permissions.hasPermission('can_remove_support_user') &&
        (this.permissions.data?.email !== orgUser?.email)
      ) {
        orgUser.dropDown[5]['disabled'] = false;
      }
      else if (orgUser.roles?.role &&
        orgUser.roles?.role?.toLowerCase() &&
        'owner' == orgUser.roles?.role?.toLowerCase() &&
        this.permissions.hasPermission('can_remove_owner_user')
      ) {
        orgUser.dropDown[5]['disabled'] = false;
      }

      else if (orgUser.roles?.role &&
        viewUser &&
        userId != orgUser.user_uid &&
        orgUser.roles?.role?.toLowerCase() &&
        !['support', 'owner'].includes(orgUser.roles?.role?.toLowerCase())
      ) {
        orgUser.dropDown[5]['disabled'] = false;
      }

      if (orgUser['invited'] !== null) {
        orgUser['invited'] = moment
          .unix(orgUser['invited'])
          .format('MMM DD, YYYY');
      }
      if (orgUser['last_access'] !== null) {
        orgUser['last_access'] = moment
          .unix(orgUser['last_access'])
          .format('MMM DD, YYYY');
      }
    }
  }

  hasProductPermission(currentUserRole: any, orgUserRole: any): boolean {
    const currentUserProducts = currentUserRole.products || {};
    const orgUserProducts = orgUserRole.products || {};
    if (orgUserRole.role.toLowerCase() == 'owner') {
      return false;
    }

    for (const key in orgUserProducts) {
      if (orgUserProducts[key] !== "None") {
        if (currentUserProducts.hasOwnProperty(key) || currentUserProducts[key] === 2) {
          return true;
        }
      }
    }
    return false;
  }

  openViewUserModal(user) {
    const initialState = {
      user: user,
    };
    this.bsModalRef = this.modalService.show(
      OrgUserProfileModalComponent,
      Object.assign(
        {},
        { class: 'modal-dialog-centered max-width-252', initialState }
      )
    );
  }

  showInvitations() {
    let updated = {
      searchData: this.searchedData,
      view: 'Invitations',
    };
    this.showInvitedUsers.emit(updated);
  }

  bannerClicked() {
    let updated = {
      searchData: this.searchQuery.search,
      type: this.searchQuery.type,
      view: 'Invitations',
    };
    this.showInvitedUsers.emit(updated);
  }

  updateSharedData() {
    const data = {
      searchedData: this.searchedData,
      rowsPerView: this.rowsPerView,
      currentPage: this.currentPage,
      sortString: this.sortString,
      sortOrder: this.sortOrder,
      filters: this.filters,
    };
    this.orgUserService.updateData(data);
  }

  kebabMenuChange($event, user) {
    if(!$event.disabled){
      if ($event.value == this.manageUserDropDownOptions[0].value) {
        this.openViewUserModal(user);
      } else if ($event.key == this.manageUserDropDownOptions[1].key) {
        this.manageUser(user);
      } else if ($event.value == this.manageUserDropDownOptions[5].value) {
        this.deleteUser(user);
      } else if ($event.key == this.manageUserDropDownOptions[2].key) {
        this.viewTeamModal(user); //
      } else if ($event.value == this.manageUserDropDownOptions[3].value) {
        this.openManageSurveyPermissions(user);
      } else if ($event.key == this.manageUserDropDownOptions[4].key) {
        this.cloneUser(user);
      }
    }
  }
  openManageSurveyPermissions(user) {
    const initialState = {
      user: user,
    };
    this.bsModalRef = this.modalService.show(
      ManageSurveyPermissionsModalComponent,
      Object.assign(
        {},
        { class: 'modal-dialog-centered xl-popup', initialState }
      )
    );
    this.bsModalRef.onHide.subscribe(() => {
      this.orgUserService.updateData({});
    })
  }

  manageUser(user: any) {
    let memberOptions = ConstantsService.getMemberOptions();
    let loggedInUserRole:any = this.permissions.role;
    if (user.roles.role === 'member') {
      memberOptions = memberOptions.map((member) => {
        if (user.roles.products) {
          const selectedProduct = user.roles.products[member.name];
          if (
            (loggedInUserRole.role === 'member' && !this.permissions.getUsersControlPermissionName(member.name))
          ) {
            return { ...member,
              selected: selectedProduct ? ConstantsService.memberRolePlaceHolders[selectedProduct] : member.selected,
              key: selectedProduct ? ConstantsService.memberRoleKeyValue[selectedProduct] : member.key,
              disabled: true };
          }
          return {
            ...member,
            selected: selectedProduct ? ConstantsService.memberRolePlaceHolders[selectedProduct] : member.selected,
            key: selectedProduct ? ConstantsService.memberRoleKeyValue[selectedProduct] : member.key,
          };
        }
        return member;
      });
    }
    this.showManageUserModal({
      selectedRole: user.roles.role,
      memberOptions: memberOptions,
      user: user,
    });
  }

  showManageUserModal(initialState) {
    const manageUserModel: any = this.modalService.show(
      NewManageUserComponent,
      { class: 'modal-dialog-centered new-manage-user-modal m-popup', initialState }
    );
    manageUserModel.onHide?.subscribe(() => {
      const content = manageUserModel.content;
      if (content.message === 'confirm') {
        const payload = {
          user_uid: content.user.user_uid,
          email: content.user.email,
          role: {
            role: content.selectedRole.toLowerCase(),
            ...(content.selectedRole == 'member' && {
              products: content.memberOptions.reduce((acc, member) => {
                acc[member.name] = member.key;
                return acc;
              }, {}),
            }),
          },
        };
        this.updateUser(payload);
      }
    });
  }

  updateUser(payload) {
    this.loader.emit(false);
    this.organisationService
      .updateOrganisationUserAndInvitedUser(payload, true)
      .subscribe((data) => {
        this.loader.emit(true);
        this.loadOrgUsers();
        this.alertList.append([{
          type: AlertType.SUCCESS,
          message: $localize`Success! Changes have been saved.`,
          keepOnRouteChange: true
        }]);
      }, (error) => {
        this.loader.emit(true);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      });
  }

  cloneUser(user: any) {
    this.loader.emit(false);
    this.organisationService.cloneUser(user.user_uid).subscribe((data) => {
      this.loader.emit(true);
      const memberOptions = this.getMembersOptions(data);
      const initialState = {
        selectedTeams: data.data.teams,
        selectedSurveys: data.data.surveys.map((survey) => ({...survey, is_permitted: true})),
        memberOptions: memberOptions,
        cloneData: user,
        selectedRole: user.roles.role === 'member' ? 'Member' : user.roles.role,
        cloned: true
      };
      this.openInviteUserModal(initialState);
    }, (error) => {
      this.loader.emit(true);
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    });
  }

  getMembersOptions(data) {
    const loggedInUserRole: any = this.permissions.role;
    return ConstantsService.getMemberOptions().map((member) => {
      if (data.data.roles.products) {
        const selectedProduct = data.data.roles.products[member.name];
        if (
          (loggedInUserRole.role === 'member' && !this.permissions.getUsersControlPermissionName(member.name))
        ) {
          return { ...member, disabled: true };
        }
        return {
          ...member,
          selected: selectedProduct ? ConstantsService.memberRolesValue[selectedProduct] : member.selected,
          key: selectedProduct ? selectedProduct : member.key,
        };
      }
      return member;
    });
  }

  openInviteUserModal(initialState) {
    this.model = this.modalService.show(NewInviteUserComponent, {
      class: 'modal-dialog-centered m-popup',
      initialState,
    });
    this.model.content.saveClick.subscribe((data) => {
      const content = this.model.content;
      if (data == 'success') {
        const payload = {
          email: content.email,
          teams: content.selectedTeams.map(
            (teams: any) => teams.global_team_uuid
          ),
          questionnaires: content.selectedSurveys.map((survey) => survey.questionnaire.id),
          role: {
            role: content.selectedRole.toLowerCase(),
            products: content.memberOptions.reduce((acc, member) => {
              acc[member.name] = member.key;
              return acc;
            }, {}),
          },
        };
        this.addUser(payload);
      } else if (data?.error) {
        this.model.content.isValid = false;
        content.errors = [{
          enabled: true,
          msg: data.error,
          name: 'wrongPattern',
        }];
      }
    });
    this.model.onHide.subscribe((data) => {
      const content = this.model.content;
      const emptyInitialData = content.selectedRole === '' && content.selectedTeams.length === 1 && content.selectedTeams[0].name === 'Default team'
        && content.selectedSurveys.length === 0 && content.email === '';
      if (content.message != 'force-close' && this.alertList.alerts.length < 1 && !emptyInitialData) {
        this.openUnsavedChangesModal(this.model.content);
      }
    });
  }

  openUnsavedChangesModal(content) {
    const unSavedModel: any = this.modalService.show(
      UnsavedChangesComponent,
      Object.assign({}, { class: 'modal-dialog-centered s-popup' })
    );
    unSavedModel.onHide.subscribe((data) => {
      if (unSavedModel.content.message === 'confirm') {
        const initialState = {
          selectedTeams: content.selectedTeams,
          selectedSurveys: content.selectedSurveys,
          memberOptions: content.memberOptions,
          cloneData: content.cloneData,
          selectedRole: content.selectedRole,
          email: content.email,
          cloned: content.cloned
        };
        this.openInviteUserModal(initialState);
      }
    });
  }

  addUser(payload: any) {
    this.loader.emit(false);
    this.organisationService.addUser(payload).subscribe((data) => {
      this.model.hide();
      this.loadOrgUsers();
      this.loader.emit(true);
      this.alertList.append([{
        type: AlertType.SUCCESS,
        message: $localize`Success! An invitation has been sent to ` + payload['email'],
        keepOnRouteChange: true
      }]);
    }, (error) => {
      if (error?.error?.data?.errors?.non_field_errors === 'Invalid email' || error?.error?.data?.errors?.non_field_errors === 'Enter a valid email address.') {
        this.model.content.saveClick.emit({ error: $localize`A valid business email address is required, please review and edit to proceed.` });
        return
      } else if(error?.error?.data?.errors?.user === 'duplicate') {
        this.model.content.saveClick.emit({ error: $localize`A user with email address ${payload.email} already exists.` });
        return
      } else if (error?.error?.data?.errors?.user_email === 'duplicate') {
        this.model.content.saveClick.emit({ error: $localize`An invitation has already been sent to ${payload.email}. Resend invitation.` });
        return;
      } else if (error?.error?.data?.errors?.operation === 'not_permitted') {
        this.model.content.saveClick.emit({ error: $localize`Xref support role can only be assigned to Xref staff.` });
        return;
      }
      this.loader.emit(true);
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    });
  }

  viewTeamModal(user): void {
    const initialState = {
      user: user,
    };
    this.bsModalRef = this.modalService.show(ManageTeamsComponent, {
      class: 'modal-dialog-centered xl-popup',
      initialState,
    });
    this.bsModalRef.content.userTeamsUpdated.subscribe((res:boolean) => {
      if(res) this.loadOrgUsers()
    });
  }

  onMenuStateChange(isOpen: boolean): void {
    this.kebabMenuOpen = isOpen;
  }

  ngAfterViewInit() {
    let container: any;
    container = document.querySelector('.user-invitee-container-post-rnp');
    if (container) {
      container.addEventListener('scroll', this.onScroll.bind(this));
    }


  }

  ngOnDestroy() {
    let container: any;
    container = document.querySelector('.user-invitee-container-post-rnp');
    if (container) {
      container.removeEventListener('scroll', this.onScroll.bind(this));
    }


  }

  onScroll(): void {
    if (this.kebabMenuOpen) {
      this.userContainer.nativeElement.click()
      const kebabMenusArray = this.kebabMenus.toArray();
      kebabMenusArray.forEach((kebabMenu: ElementRef) => {
        const button = kebabMenu.nativeElement.children[0]?.children[0]?.children[0];
        if (button) {
          button.blur();
        }
      });
    }


  }
}
